// extracted by mini-css-extract-plugin
export default {"appear":"MyrtechNavBar_appear__l3p+n","slideDown":"MyrtechNavBar_slideDown__vODZq","disappear":"MyrtechNavBar_disappear__EV2Tr","slideUp":"MyrtechNavBar_slideUp__4YyWB"};